import { useEffect, useState, useRef } from "react";
import { Button } from "react-bootstrap";
import {
  Calendar,
  ChevronUp,
  ChevronDown,
  Search,
  ArrowLeft,
  X,
} from "lucide-react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import {
  mondayDayYearFormat,
  handleError,
  formatBookingId,
  formatDateStringdot,
} from "../../CommonJquery/CommonJquery";
import {
  APL_LINK,
  server_post_data,
  get_driver_lager_data,
  get_toll_details_data,
} from "../../ServiceConnection/serviceconnection";
import Loader from "../Loader";
import ViewServiceCharge from "./ViewServiceCharge";
import { Modal } from "react-bootstrap";
const AllTransactions = ({
  activeSection,
  driverData,
  ledgerData,
  ledgerDataFilter,
  imageLink,
  setSelectedDriverId,
  selectedDriverId,
  setSelectedDriverBookingId,
  selectedDriverBookingId,
  selectedDriver,
  setSelectedDriver,
  setStartDate,
  startDate,
  setEndDate,
  endDate,
  dateRangeType,
  setDateRangeType,
  master_data_get,
  flag,
}) => {
  const [showLoaderAdmin, setshowLoaderAdmin] = useState(false);
  const [isDriverDropdownOpen, setIsDriverDropdownOpen] = useState(false);
  const [driverSearchQuery, setDriverSearchQuery] = useState("");
  const driverDropdownRef = useRef(null);
  const [currentScreen, setCurrentScreen] = useState("transactions");
  const [tollChargesData, setTollChargesData] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [selectedTransaction, setSelectedTransaction] = useState(null);

  const capitalizeWords = (str) => {
    return str.replace(/\b\w/g, (char) => char.toUpperCase());
  };

  // const getMasterData = () => {
  //   console.log("hitted the transaction data");
  //   master_data_get(startDate, endDate, 2, 7, selectedDriverId);
  // };

  // expose the method
  // useImperativeHandle(ref, () => ({
  //   getMasterData,
  // }));

  // Fix: Only search by name and ID (which exists in the driver objects)
  // const filteredDrivers = driverData
  //   ? driverData.filter(
  //       (driver) =>
  //         (driver.name ? driver.name : "").includes(driverSearchQuery) ||
  //         (driver.primary_id ? driver.primary_id.toString() : "").includes(
  //           driverSearchQuery
  //         )
  //     )
  //   : [];

  const filteredDrivers = driverData
    ? driverData.filter((driver) => {
        const searchQuery = driverSearchQuery.toLowerCase().trim();
        const driverName = (driver.name || "").toLowerCase();
        const driverId = (driver.primary_id || "").toString();

        return (
          driverName.startsWith(searchQuery) || driverId.startsWith(searchQuery)
        );
      })
    : [];

  const handleSelectDriver = (driver) => {
    console.log(driver);
    // console.log(
    //   "river.booking_data.primary_id",
    //   driver.booking_data.primary_id
    // );
    if (driver == null) {
      setSelectedDriverId(0);
      master_data_get(startDate, endDate, 2, 7, 0, 0);
      setIsDriverDropdownOpen(false);
      setDriverSearchQuery("");
    } else {
      setSelectedDriver(driver);
      setSelectedDriverId(driver.primary_id);
      setSelectedDriverBookingId(driver?.booking_data?.primary_id || 0);
      master_data_get("", "", 2, 7, driver.primary_id, 0);
      setIsDriverDropdownOpen(false);
      setDriverSearchQuery("");
    }
  };

  useEffect(() => {
    function handleClickOutside(event) {
      if (
        driverDropdownRef.current &&
        !driverDropdownRef.current.contains(event.target)
      ) {
        setIsDriverDropdownOpen(false);
      }
    }

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [driverDropdownRef]);

  function format24HourTime(dateTimeString) {
    const date = new Date(dateTimeString);

    // Get hours and minutes in 24-hour format
    const hours = date.getHours().toString().padStart(2, "0");
    const minutes = date.getMinutes().toString().padStart(2, "0");

    return `${hours}:${minutes}`;
  }

  // Transaction data stored in a constant

  const handlePaymentType = (type) => {
    const lowerType = type;
    // const lowerType = type.toLowerCase();
    switch (lowerType) {
      case "cash":
        return {
          type: "Cash",
          icon: "bi-cash",
          class: "accounting-cash",
        };
      case "Cash":
        return {
          type: "Cash",
          icon: "bi-cash",
          class: "accounting-cash",
        };
      case "stripe":
        return {
          type: "Stripe",
          icon: "bi-credit-card",
          class: "accounting-stripe",
        };
      case "Stripe":
        return {
          type: "Stripe",
          icon: "bi-credit-card",
          class: "accounting-stripe",
        };
      case "zelle":
        return {
          type: "Zelle",
          icon: "bi-currency-dollar",
          class: "accounting-zelle",
        };
      case "Zelle":
        return {
          type: "Zelle",
          icon: "bi-currency-dollar",
          class: "accounting-zelle",
        };
      case "card":
        return {
          type: "Card",
          icon: "bi-phone",
          class: "accounting-upi",
        };
      case "Online (Credit/Debit Card)":
        return {
          type: "Online",
          icon: "bi-phone",
          class: "accounting-upi",
        };
      case "Card":
        return {
          type: "Card",
          icon: "bi-phone",
          class: "accounting-upi",
        };
      default:
        return {
          type: "Unknown",
          icon: "bi-question-circle",
          class: "accounting-unknown",
        };
    }
  };

  // Handle date range change
  const handleDateRangeChange = (e) => {
    const value = e.target.value;
    setDateRangeType(value);
    //console.log("value", value);
    flag = 2;
    master_data_get(
      startDate,
      endDate,
      flag,
      value,
      selectedDriverId,
      selectedDriverBookingId
    );
    // Reset custom date range when switching to predefined ranges
    if (value !== "custom") {
      setStartDate(null);
      setEndDate(null);
    }
  };

  const handlecustomDate = () => {
    if (selectedDriverId != 0) {
      master_data_get(
        startDate,
        endDate,
        2,
        "custom",
        selectedDriverId,
        selectedDriverBookingId
      );
    } else {
      master_data_get(startDate, endDate, 2, "custom", 0, 0);
    }
  };

  // console.log(ledgerData);
  // const mergedTableData = [];

  const mergedTableData = [];

  // Rent Ledger → Debit
  ledgerData?.rentledger_data?.forEach((entry) => {
    mergedTableData.push({
      date: entry.entry_date, // assuming 'created_at' holds timestamp
      entry_date: entry.entry_date, // assuming 'created_at' holds timestamp
      affected_date: entry.week_start_date, // assuming 'affected at' holds timestamp
      // description: `Rent Generated on ${entry.week_start_date}`,
      booking_id:
        (entry?.booking_id && formatBookingId(entry.booking_id)) || "-",
      description: `Rent Generated ${
        entry?.payment_day_week == 2
          ? "Upto " + mondayDayYearFormat(entry.max_payment_date)
          : " "
      }`,
      debit: entry.total_rent_sum,
      credit: null,
      payment_mode: "-",
      source: "Admin",
      type: "Rent",
      transaction_id: entry.unique_id,
      driver_name:
        driverData.find((d) => d.primary_id === entry.user_id)?.name || null,
    });
  });

  // Service Charges → Debit
  ledgerData?.service_charge_data?.forEach((entry) => {
    const details = [];
    if (entry.toll_charge || entry.total_toll_charge)
      details.push(`Toll: $${entry.toll_charge || entry.total_toll_charge}`);
    if (entry.damage_charge || entry.total_damage_charge)
      details.push(
        `Damage: $${entry.damage_charge || entry.total_damage_charge}`
      );
    if (entry.ticket_charge || entry.total_ticket_charge)
      details.push(
        `Ticket: $${entry.ticket_charge || entry.total_ticket_charge}`
      );
    if (entry.other_charge || entry.total_other_charge)
      details.push(`Other: $${entry.other_charge || entry.total_other_charge}`);

    const total =
      (entry.toll_charge || entry.total_toll_charge || 0) +
      (entry.damage_charge || entry.total_damage_charge || 0) +
      (entry.ticket_charge || entry.total_ticket_charge || 0) +
      (entry.other_charge || entry.total_other_charge || 0);

    mergedTableData.push({
      date: entry.entry_date || entry.min_entry_date,
      entry_date: entry.entry_date || entry.min_entry_date,
      affected_date: entry.service_date,
      booking_id: formatBookingId(entry.booking_id) || "-",
      description: `Service Charges (${details.join(", ")})`,
      debit: total,
      credit: null,
      payment_mode: "-",
      source: "Admin",
      type: "Charge",
      transaction_id: entry.primary_id?.toString() || entry.unique_id || "-",
      // for the view functionality by harsh
      showViewButton:
        entry.max_primary_id &&
        entry.min_primary_id &&
        entry.max_primary_id !== entry.min_primary_id,
      serviceChargeEntry: entry,
      driver_name:
        driverData.find((d) => d.primary_id === entry.user_id)?.name || null,
    });
  });

  // Discounts → Debit
  ledgerData?.discount_data?.forEach((entry) => {
    const details = [];
    if (entry.rent_discount) details.push(`Rent: $${entry.rent_discount}`);
    if (entry.toll_discount) details.push(`Toll: $${entry.toll_discount}`);
    if (entry.damage_discount)
      details.push(`Damage: $${entry.damage_discount}`);
    if (entry.ticket_discount)
      details.push(`Ticket: $${entry.ticket_discount}`);
    if (entry.latefees_discount)
      details.push(`Late Fees: $${entry.latefees_discount}`);
    if (entry.other_charges_discount)
      details.push(`Other: $${entry.other_charges_discount}`);

    const totalDiscount =
      (entry.rent_discount || 0) +
      (entry.toll_discount || 0) +
      (entry.damage_discount || 0) +
      (entry.ticket_discount || 0) +
      (entry.latefees_discount || 0) +
      (entry.other_charges_discount || 0);

    mergedTableData.push({
      date: entry.entry_date,
      entry_date: entry.entry_date,
      affected_date: entry.discount_date,
      booking_id: formatBookingId(entry.booking_id) || "-",
      description:
        entry.discount_or_adjustment == 0
          ? `Discount Provided (${details.join(", ")})`
          : entry.discount_or_adjustment == 1
          ? entry.notes
          : `Rent Adjustment Provided (${details.join(", ")})`,
      debit: totalDiscount,
      credit: null,
      payment_mode: "-",
      source: "Admin",
      type: entry.discount_or_adjustment == 0 ? "Discount" : "Adjustment",
      transaction_id: "-",
      driver_name:
        driverData.find((d) => d.primary_id === entry.user_id)?.name || null,
    });
  });

  // Payments → Credit
  ledgerData?.payment_data?.forEach((entry) => {
    const paymentDetails = [];
    if (entry.rent) paymentDetails.push(`Rent: $${entry.rent}`);
    if (entry.tolls) paymentDetails.push(`Toll: $${entry.tolls}`);
    if (entry.damagefees) paymentDetails.push(`Damage: $${entry.damagefees}`);
    if (entry.tickets) paymentDetails.push(`Ticket: $${entry.tickets}`);
    if (entry.other_charges)
      paymentDetails.push(`Other: $${entry.other_charges}`);
    if (entry.deposit) paymentDetails.push(`Deposit: $${entry.deposit}`);
    if (entry.total_advance)
      paymentDetails.push(`Advance: $${entry.total_advance}`);
    mergedTableData.push({
      date: entry.entry_date,
      entry_date: entry.entry_date,
      affected_date: entry.payment_date,
      booking_id: formatBookingId(entry.booking_id) || "-",
      description:
        entry.refund_status == 0
          ? `Payment Recieved (${paymentDetails.join(", ")})`
          : `Refund Provided`,
      debit: entry.refund_status == 0 ? null : entry.total_amount,
      credit: entry.refund_status == 1 ? null : entry.total_amount,
      payment_mode: entry.payment_mode || "-",
      source: entry?.entry_from == 1 ? "Driver" : "Admin",
      type: "Payment",
      transaction_id: entry.transaction_id,
      driver_name:
        driverData.find((d) => d.primary_id === entry.user_id)?.name || null,
    });
  });

  // Reallocations → Payment
  ledgerData?.payment_reallocation?.forEach((entry) => {
    const paymentDetails = [];
    if (entry.rent) paymentDetails.push(`Rent: $${entry.rent}`);
    if (entry.tolls) paymentDetails.push(`Toll: $${entry.tolls}`);
    if (entry.damagefees) paymentDetails.push(`Damage: $${entry.damagefees}`);
    if (entry.tickets) paymentDetails.push(`Ticket: $${entry.tickets}`);
    if (entry.other_charges)
      paymentDetails.push(`Other: $${entry.other_charges}`);
    if (entry.deposit) paymentDetails.push(`Deposit: $${entry.deposit}`);
    if (entry.total_advance) paymentDetails.push(`Advance: $${entry.deposit}`);
    mergedTableData.push({
      date: entry.entry_date,
      entry_date: entry.entry_date,
      affected_date: entry.entry_date,
      booking_id: formatBookingId(entry.booking_id) || "-",
      description: `Payment Reallocation ($${entry.total_adjusted_amount})`,
      debit: entry.refund_status == 0 ? null : entry.total_amount,
      credit: entry.refund_status == 1 ? null : entry.total_amount,
      payment_mode: entry.payment_mode || "-",
      source: entry?.entry_from == 1 ? "Driver" : "Admin",
      type: "Reallocation",
      transaction_id: entry.transaction_id,
      reaalocation_details: entry.payment_details,
      driver_name:
        driverData.find((d) => d.primary_id === entry.user_id)?.name || null,
      total_adjusted_amount: entry.total_adjusted_amount,
    });
  });
  // function to handle view button click by harsh
  const handleViewServiceCharge = async (serviceChargeEntry) => {
    setshowLoaderAdmin(true);
    const fd = new FormData();
    fd.append("unique_id", serviceChargeEntry.unique_id);
    fd.append("user_id", serviceChargeEntry.user_id);
    fd.append("booking_id", serviceChargeEntry.booking_id);

    try {
      const response = await server_post_data(get_toll_details_data, fd);
      console.log("API Response (get_toll_details_data):", response.data); // Debug log
      if (response.data.error) {
        handleError(response.data.message);
      } else {
        console.log("tollDetails:", response.data.data); // Debug log for tollDetails
        setCurrentScreen("Service-Charge");
        setTollChargesData(response.data.data);
      }
    } catch (error) {
      handleError("network");
    } finally {
      setshowLoaderAdmin(false);
    }
  };

  // Descending (newest first)
  const sortByDateDesc = (dataArray) => {
    return dataArray.sort(
      (a, b) => new Date(b.entry_date) - new Date(a.entry_date)
    );
  };

  let dataArray = sortByDateDesc(mergedTableData);

  // Use this array to map your table
  console.log(mergedTableData, driverData);

  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  // Get paginated data
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = dataArray
    ? dataArray.slice(indexOfFirstItem, indexOfLastItem)
    : [];
  const totalPages = dataArray ? Math.ceil(dataArray.length / itemsPerPage) : 0;

  // Handler for page changes
  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  // Render pagination buttons
  const renderPaginationButtons = () => {
    const buttons = [];

    // Previous button
    buttons.push(
      <li className="cust_hist_page_item" key="prev">
        <button
          className="cust_hist_page_link cust_hist_page_prev"
          onClick={() => handlePageChange(currentPage - 1)}
          disabled={currentPage === 1}
        >
          <span className="sr-only">Previous</span>
          <svg
            className="cust_hist_page_icon"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 20 20"
            fill="currentColor"
            aria-hidden="true"
          >
            <path
              fillRule="evenodd"
              d="M12.707 5.293a1 1 0 010 1.414L9.414 10l3.293 3.293a1 1 0 01-1.414 1.414l-4-4a1 1 0 010-1.414l4-4a1 1 0 011.414 0z"
              clipRule="evenodd"
            />
          </svg>
        </button>
      </li>
    );

    // Page buttons
    // Show max 5 page buttons with current page in the middle when possible
    let startPage = Math.max(1, currentPage - 2);
    let endPage = Math.min(totalPages, startPage + 4);

    // Adjust startPage if endPage is at maximum
    if (endPage === totalPages) {
      startPage = Math.max(1, endPage - 4);
    }

    for (let i = startPage; i <= endPage; i++) {
      buttons.push(
        <li className="cust_hist_page_item" key={i}>
          <button
            className={`cust_hist_page_link ${
              currentPage === i ? "cust_hist_page_active" : ""
            }`}
            onClick={() => handlePageChange(i)}
          >
            {i}
          </button>
        </li>
      );
    }

    // Next button
    buttons.push(
      <li className="cust_hist_page_item" key="next">
        <button
          className="cust_hist_page_link cust_hist_page_next"
          onClick={() => handlePageChange(currentPage + 1)}
          disabled={currentPage === totalPages || totalPages === 0}
        >
          <span className="sr-only">Next</span>
          <svg
            className="cust_hist_page_icon"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 20 20"
            fill="currentColor"
            aria-hidden="true"
          >
            <path
              fillRule="evenodd"
              d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z"
              clipRule="evenodd"
            />
          </svg>
        </button>
      </li>
    );

    return buttons;
  };

  const handleViewClick = (transaction) => {
    setSelectedTransaction(transaction);
    console.log(transaction.reaalocation_details);
    setShowModal(true);
  };
  return (
    <>
      {showLoaderAdmin && <Loader />}
      {currentScreen == "transactions" && (
        <section
          id="all-transactions"
          className={`accounting-section ${
            activeSection === "all-transactions" ? "" : "accounting-hidden"
          }`}
        >
          {/* <div className="accounting-section-header">
          <h2 className="accounting-section-title">All Transactions</h2>
          <div className="accounting-header-actions">
            <button
            className="accounting-btn accounting-btn-primary"
            onClick={() =>
              handleExportCSV(filteredTransactions, "transactions.csv")
            }
          >
            Export CSV
          </button>
          </div>
        </div> */}

          <div className="accounting-filters">
            <div className="accounting-filter-group">
              <label htmlFor="driver-select" className="accounting-label">
                Select Driver
              </label>
              <div className="position-relative" ref={driverDropdownRef}>
                <div
                  className="form-floating form-control shadow-sm d-flex justify-content-between align-items-center cursor-pointer"
                  onClick={() => setIsDriverDropdownOpen(!isDriverDropdownOpen)}
                  style={{
                    cursor: "pointer",
                    height: "40px",
                    // paddingTop: "10px",
                    marginTop: "6px",
                  }}
                >
                  {selectedDriverId === 0 ? (
                    <div className="fw-medium">All Drivers</div>
                  ) : (
                    <>
                      {selectedDriver ? (
                        <div className="fw-medium">
                          {selectedDriver.name}{" "}
                          {selectedDriver.plan
                            ? `${selectedDriver.plan} - `
                            : ""}
                          {selectedDriver.driverId}
                        </div>
                      ) : (
                        <div className="">All Drivers</div>
                      )}
                    </>
                  )}
                  <div
                    className="position-absolute"
                    style={{
                      bottom: "6px",
                      right: "10px",
                      pointerEvents: "none",
                    }}
                  >
                    {isDriverDropdownOpen ? (
                      <ChevronUp size={16} />
                    ) : (
                      <ChevronDown size={16} />
                    )}
                  </div>
                </div>

                {isDriverDropdownOpen && (
                  <div
                    className="position-absolute w-100 bg-white shadow-lg rounded-bottom z-index-1000"
                    style={{ zIndex: 1000 }}
                  >
                    <div className="p-2 border-bottom">
                      <div className="input-group">
                        <span
                          className="input-group-text bg-white border-end-0"
                          style={{ marginTop: "5px" }}
                        >
                          <Search size={16} />
                        </span>
                        <input
                          type="text"
                          className="form-control border-start-0"
                          placeholder="Search by name or ID..."
                          value={driverSearchQuery}
                          onChange={(e) => setDriverSearchQuery(e.target.value)}
                          autoFocus
                        />
                      </div>
                    </div>
                    <div style={{ maxHeight: "250px", overflowY: "auto" }}>
                      <div
                        key={0}
                        className="p-2 border-bottom hover-bg-light cursor-pointer"
                        onClick={() => handleSelectDriver(null)}
                        style={{ cursor: "pointer" }}
                      >
                        <div
                          className="fw-medium"
                          onClick={() => handleSelectDriver(null)}
                        >
                          All Drivers
                        </div>
                      </div>
                      {filteredDrivers.length > 0 ? (
                        filteredDrivers.map((driver) => (
                          <div
                            key={driver.primary_id}
                            className="p-2 border-bottom hover-bg-light cursor-pointer"
                            onClick={() => handleSelectDriver(driver)}
                            style={{ cursor: "pointer" }}
                          >
                            <div className="fw-medium">{driver.name}</div>
                            <div className="small text-muted">
                              ID: {driver.primary_id}
                            </div>
                          </div>
                        ))
                      ) : (
                        <div className="p-3 text-center text-muted">
                          No drivers found
                        </div>
                      )}
                    </div>
                  </div>
                )}
              </div>
            </div>

            <div className="accounting-filter-group">
              <label htmlFor="date-range" className="accounting-label">
                Date Range
              </label>
              <select
                id="date-range"
                className="accounting-select"
                value={dateRangeType}
                onChange={handleDateRangeChange}
              >
                <option value="7">Last 7 Days</option>
                <option value="30">Last 30 Days</option>
                <option value="90">Last 90 Days</option>
                <option value="custom">Custom Range</option>
              </select>
            </div>

            {dateRangeType === "custom" && (
              // <div className="accounting-custom-date-range">
              <>
                <div className="accounting-filter-group">
                  <label htmlFor="start-date" className="accounting-label">
                    From Date
                  </label>
                  <div className="accounting-date-input-wrapper">
                    <DatePicker
                      id="start-date"
                      selected={startDate}
                      onChange={(date) => setStartDate(date)}
                      selectsStart
                      startDate={startDate}
                      endDate={endDate}
                      className="accounting-date-inputAll"
                      placeholderText="MM/DD/YYYY"
                      dateFormat="MM/dd/yyyy"
                    />
                    <Calendar className="accounting-date-icon" size={18} />
                  </div>
                </div>
                <div className="accounting-filter-group">
                  <label htmlFor="end-date" className="accounting-label">
                    To Date
                  </label>
                  <div className="accounting-date-input-wrapper">
                    <DatePicker
                      id="end-date"
                      selected={endDate}
                      onChange={(date) => setEndDate(date)}
                      selectsEnd
                      startDate={startDate}
                      endDate={endDate}
                      minDate={startDate}
                      className="accounting-date-inputAll"
                      placeholderText="MM/DD/YYYY"
                      dateFormat="MM/dd/yyyy"
                    />
                    <Calendar className="accounting-date-icon" size={18} />
                  </div>
                </div>
                <div className="accounting-header-actionsAll">
                  <button
                    className="accounting-btn accounting-btn-primary"
                    onClick={handlecustomDate}
                    style={{ height: "42px" }}
                  >
                    Search
                  </button>
                </div>
              </>
              // </div>
            )}
          </div>

          <div className="accounting-table-container">
            <table className="accounting-table">
              <thead>
                <tr>
                  <th style={{ whiteSpace: "nowrap" }}>Entry Date</th>
                  <th style={{ whiteSpace: "nowrap" }}>Effective Date</th>
                  <th style={{ whiteSpace: "nowrap" }}>Driver Name</th>
                  <th style={{ whiteSpace: "nowrap" }}>Booking ID</th>
                  <th style={{ whiteSpace: "nowrap" }}>Description</th>
                  <th style={{ whiteSpace: "nowrap" }}>Debit ($)</th>
                  <th style={{ whiteSpace: "nowrap" }}>Credit ($)</th>
                  <th style={{ whiteSpace: "nowrap" }}>Payment Mode</th>
                  <th style={{ whiteSpace: "nowrap" }}>Source</th>
                  <th style={{ whiteSpace: "nowrap" }}>Type</th>
                  <th style={{ whiteSpace: "nowrap" }}>Transaction ID</th>
                  {/* <th style={{ whiteSpace: "nowrap" }}>Actions</th> */}
                </tr>
              </thead>
              <tbody>
                {currentItems &&
                  currentItems.map((transaction, index) => (
                    <tr key={index}>
                      <td>{mondayDayYearFormat(transaction.date)}</td>
                      <td>{mondayDayYearFormat(transaction.affected_date)}</td>
                      <td>{transaction.driver_name}</td>
                      <td>
                        {transaction.booking_id != "-" && "#"}
                        {transaction.booking_id}
                      </td>
                      <td>{transaction.description}</td>
                      <td style={{ color: "red" }}>
                        {transaction?.debit?.toFixed(2) || "-"}
                      </td>
                      <td style={{ color: "green" }}>
                        {transaction?.credit?.toFixed(2) || "-"}
                      </td>
                      <td>
                        <div
                          className={` ${
                            transaction?.payment_mode !== "-"
                              ? "accounting-payment-mode"
                              : "accounting-payment-mode2"
                          } ${
                            handlePaymentType(transaction.payment_mode).class
                          }`}
                        >
                          {transaction?.payment_mode !== "-"
                            ? handlePaymentType(transaction.payment_mode).type
                            : transaction?.payment_mode}
                        </div>
                      </td>
                      <td>
                        <span
                          className={`accounting-status accounting-status-${
                            transaction.source == "Driver"
                              ? "credit_user"
                              : "credit_admin"
                          }`}
                        >
                          {transaction.source}
                        </span>
                      </td>
                      <td>
                        <span
                          className={`accounting-status accounting-status-${
                            transaction.debit == "" || transaction.debit == null
                              ? "credit"
                              : "debit"
                          }`}
                        >
                          {transaction.type}
                        </span>
                      </td>
                      <td>
                        {transaction.type == "Reallocation" ? (
                          <button
                            className="accounting-btn accounting-btn-sm accounting-btn-secondary"
                            onClick={() => handleViewClick(transaction)}
                            style={{ fontSize: "12px", padding: "4px 8px" }}
                          >
                            View Details
                          </button>
                        ) : (
                          <>
                            {transaction.showViewButton ? (
                              <button
                                className="accounting-btn accounting-btn-sm accounting-btn-secondary"
                                onClick={() =>
                                  handleViewServiceCharge(
                                    transaction.reaalocation_details
                                  )
                                }
                                style={{
                                  fontSize: "12px",
                                  padding: "4px 8px",
                                }}
                              >
                                View Details
                              </button>
                            ) : (
                              <>
                                {transaction.transaction_id
                                  ? transaction?.transaction_id.slice(0, 15) +
                                    `${
                                      transaction.transaction_id.lenght > 15
                                        ? "..."
                                        : ""
                                    }`
                                  : "-"}
                              </>
                            )}
                          </>
                        )}
                      </td>
                    </tr>
                  ))}
              </tbody>
            </table>
          </div>

          <div className="cust_hist_card_footer">
            <div className="cust_hist_pagination_info">
              {mergedTableData && mergedTableData.length > 0 ? (
                <>
                  Showing{" "}
                  <span className="cust_hist_pagination_bold">
                    {indexOfFirstItem + 1}
                  </span>{" "}
                  to{" "}
                  <span className="cust_hist_pagination_bold">
                    {Math.min(indexOfLastItem, mergedTableData.length)}
                  </span>{" "}
                  of{" "}
                  <span className="cust_hist_pagination_bold">
                    {mergedTableData.length}
                  </span>{" "}
                  transactions
                </>
              ) : (
                <>
                  Showing <span className="cust_hist_pagination_bold">0</span>{" "}
                  transactions
                </>
              )}
            </div>
            <div className="cust_hist_pagination">
              <nav aria-label="Pagination">
                <ul className="cust_hist_pagination_list">
                  {renderPaginationButtons()}
                </ul>
              </nav>
            </div>
          </div>
        </section>
      )}

      {currentScreen == "Service-Charge" && (
        <section
          id="all-transactions"
          className={`accounting-section ${
            activeSection === "all-transactions" ? "" : "accounting-hidden"
          }`}
        >
          <div className="d-flex mb-2 justify-content-end w-100">
            <Button
              startIcon={
                <ArrowLeft size={17} style={{ marginBottom: "2px" }} />
              }
              className="Back_bttn_page"
              style={{ alignSelf: "flex-end" }}
              onClick={() => setCurrentScreen("transactions")}
            >
              Back
            </Button>
          </div>

          <ViewServiceCharge tollChargesData={tollChargesData} />
        </section>
      )}

      {/* Transaction Details Modal */}
      <Modal
        show={showModal}
        onHide={() => setShowModal(false)}
        centered
        size="lg"
        className="transaction-details-modal"
      >
        <Modal.Header className="border-0 pb-0">
          <Modal.Title className="w-100 text-left">
            Reallocation Details
          </Modal.Title>
          <Button
            variant="link"
            onClick={() => setShowModal(false)}
            className="close-button p-0 position-absolute"
          >
            <X size={20} color="#5B93FF" />
          </Button>
        </Modal.Header>
        {selectedTransaction && (
          <Modal.Body className="pb-4">
            <div className="accounting-services-due">
              <div className="accounting-services-header p-0">
                <div
                  className="accounting-service-item"
                  style={{ borderBottom: "0" }}
                >
                  <div className="accounting-service-info">
                    <div className="accounting-service-checkbox">
                      <label
                        htmlFor="rent_amount"
                        className="accounting-service-label"
                      >
                        <span
                          className="accounting-service-name"
                          style={{ width: "165px" }}
                        >
                          From Head
                        </span>
                      </label>
                    </div>
                  </div>

                  <div className="accounting-service-amount">
                    <label
                      htmlFor="rent_amount"
                      className="accounting-service-label"
                    >
                      <span
                        className="accounting-service-name"
                        style={{ width: "165px" }}
                      >
                        To Head
                      </span>
                    </label>
                  </div>

                  <div className="accounting-service-amount">
                    <label
                      htmlFor="rent_amount"
                      className="accounting-service-label"
                    >
                      <span
                        className="accounting-service-name"
                        style={{ width: "102px" }}
                      >
                        Settle Amt.
                      </span>
                    </label>
                  </div>
                </div>
              </div>

              <div className="accounting-services-list">
                {/* damage Row */}
                {selectedTransaction.reaalocation_details &&
                  selectedTransaction.reaalocation_details.length > 0 &&
                  selectedTransaction.reaalocation_details.map(
                    (transection) => (
                      <div className="accounting-service-item">
                        <div className="accounting-service-info">
                          <div className="accounting-service-checkbox">
                            <label
                              htmlFor="latefees"
                              className="accounting-service-label"
                            >
                              <span
                                className="accounting-service-name"
                                style={{ width: "165px" }}
                              >
                                {capitalizeWords(transection?.from_head)}
                              </span>
                            </label>
                          </div>
                        </div>
                        <div className="accounting-service-info">
                          <div className="accounting-service-checkbox">
                            <label
                              htmlFor="latefees"
                              className="accounting-service-label"
                            >
                              <span
                                className="accounting-service-name"
                                style={{ width: "165px" }}
                              >
                                {capitalizeWords(transection?.to_head)}
                              </span>
                            </label>
                          </div>
                        </div>
                        <div className="accounting-service-amount">
                          <span
                            className="accounting-amount-due"
                            style={{ width: "102px", textAlign: "left" }}
                          >
                            ${transection?.amount || 0}
                          </span>
                        </div>
                      </div>
                    )
                  )}

                <div
                  className="accounting-service-total py-0 justify-content-end align-items-center gap-4"
                  style={{ height: "60px" }}
                >
                  <div
                    className="d-flex justify-content-end align-items-center"
                    style={{
                      borderRight: "1px solid #d9d9d9",
                      height: "100%",
                      paddingRight: "1.5rem ",
                    }}
                  >
                    <span className="accounting-total-label">Total Amount</span>
                  </div>
                  <div style={{ width: "102px" }}>
                    <span className="accounting-total-amount">$</span>
                    <span className="accounting-total-amount totlamt">
                      {selectedTransaction?.total_adjusted_amount}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </Modal.Body>
        )}
      </Modal>
    </>
  );
};

export default AllTransactions;
